export default __webpack_public_path__ + "static/media/support.e6acb168.svg";